<template>
    <table class="table table-app table-striped">
        <thead>
        <tr>
            <th class="d-none d-sm-table-cell">Name</th>
            <th class="d-none d-lg-table-cell">Employer</th>
            <th class="d-none d-md-table-cell">Technician</th>
            <th class="d-none d-sm-table-cell">Started</th>
        </tr>
        </thead>
        <tbody>
            <tr v-for="project in projects"
                :key="project.id"
                @click="openDashboard(project)"
                :class="projectClassRow(project)">
            <td>
                <a :href="`/projects/${project.slug}`" class="project-info">
                   <div class="project-name" v-text="strlimit(project.name)"></div>
                   <div class="project-number" v-text="project.number"></div>
                </a>
            </td>
            <td class="d-none d-lg-table-cell">
                <user-presentation-card :user="project.employer" :att="false"></user-presentation-card>
            </td>
            <td class="d-none d-md-table-cell">
                <user-presentation-card :user="project.responsible" :ate="false" v-if="project.responsible"></user-presentation-card>
            </td>
            <td class="d-none d-sm-table-cell">
                <div v-if="project.is_started" v-text="classicDate(project.started_at)"></div>
                <div v-else>Not Started</div>
                <div class="text-sm text-success" v-if="project.is_completed && !project.is_void" v-text="shortDate(project.completed_at)"></div>
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
    export default {

        props:{
            projects:{
                type: Array,
                required: true,
            }
        },

        methods:{
            openDashboard(project) {
                if (this.isMobileDevice) {
                    this.redirectTo(`/projects/${project.slug}`);
                }
            },

            projectClassRow(project){
                return {
                    'not-started': !project.is_started,
                    'in-progress': project.is_started && project.is_not_completed,
                    'completed' : project.is_completed,
                    'void' : project.is_void,
                }
            }
        }

    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>
